import { useShellContext } from "@insite/client-framework/Components/IsInShell";
import * as React from "react";
import styled from "styled-components";

interface Props {
    type: string;
    isWidget: boolean;
}

const MissingComponentStyle = styled.div`
    color: red;
`;

const MissingComponent: React.FunctionComponent<Props> = props => {
    const { isWidget, type } = props;
    const { isInShell } = useShellContext();
    if (isInShell) {
        return (
            <MissingComponentStyle>
                There was no {isWidget ? "widget" : "page"} found for {type}
            </MissingComponentStyle>
        );
    }

    return null;
};

export default MissingComponent;
